'use strict';

import { register } from '../../../JavaScript/Utils';

const parseBool = (value) => String(value) === '1' || String(value).toLowerCase() === 'true';

const openPopup = (modal) => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-promotiontimer-popup');
};

const closePopup = (modal) => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-promotiontimer-popup');
};

const bindEsc = (modal) => {
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
            closePopup(modal);
        }
    });
};

const bindManualOpen = (modal, popupId) => {
    const selectors = ['[data-action="open-promotion-popup"]'];
    if (popupId) {
        selectors.push(`[data-promotiontimer-open="${popupId}"]`);
    }

    document.querySelectorAll(selectors.join(',')).forEach((node) => {
        node.addEventListener('click', (event) => {
            event.preventDefault();
            openPopup(modal);
        });
    });
};

const bindDismissActions = (modal, closeOnBackdrop) => {
    modal.querySelectorAll('[data-action=\"dismiss-promotion-popup\"]').forEach((node) => {
        node.addEventListener('click', (event) => {
            if (!closeOnBackdrop && node.classList.contains('content__promotiontimer-modal-overlay')) {
                return;
            }
            event.preventDefault();
            closePopup(modal);
        });
    });
};

const setupTrigger = (modal, triggerType, delayMs) => {
    const delayedOpen = () => {
        window.setTimeout(() => {
            openPopup(modal);
        }, delayMs);
    };

    if (triggerType === 'on_load') {
        delayedOpen();
        return;
    }

    if (triggerType === 'scroll_depth') {
        const onScroll = () => {
            const scrollable = document.documentElement.scrollHeight - window.innerHeight;
            if (scrollable <= 0) {
                return;
            }
            const depth = (window.scrollY / scrollable) * 100;
            if (depth >= 50) {
                window.removeEventListener('scroll', onScroll);
                delayedOpen();
            }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        return;
    }

    if (triggerType === 'exit_intent') {
        const onMouseOut = (event) => {
            if (event.clientY <= 0) {
                document.removeEventListener('mouseout', onMouseOut);
                delayedOpen();
            }
        };
        document.addEventListener('mouseout', onMouseOut);
        return;
    }

    if (triggerType === 'manual_click') {
        // Popup stays hidden until opened by custom integration.
        return;
    }

    delayedOpen();
};

const promotionTimerPopup = (el) => {
    const triggerType = el.dataset.popupTrigger || 'on_load';
    const delayMs = parseInt(el.dataset.popupDelay || '0', 10);
    const overlayOpacity = Math.min(100, Math.max(0, parseInt(el.dataset.popupOverlayOpacity || '55', 10)));
    const closeOnBackdrop = parseBool(el.dataset.popupCloseOnBackdrop || '1');
    const popupId = el.dataset.popupId || '';

    el.style.setProperty('--promotiontimer-overlay-opacity', String(overlayOpacity / 100));
    bindDismissActions(el, closeOnBackdrop);
    bindEsc(el);
    bindManualOpen(el, popupId);
    setupTrigger(el, triggerType, Math.max(0, delayMs));
};

register('PromotionTimerPopup', promotionTimerPopup);
